import React from 'react';
import NpiLookup from '../NpiLookup';

/** Purpose: Renders the Add Provider modal dialog. Inputs: props object. Output: React render output (JSX). */
function AddProviderModal({
  open,
  onClose,
  providerForm,
  setProviderForm,
  providerError,
  isSavingProvider,
  onSubmit
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <form onSubmit={onSubmit} className="bg-white rounded-xl shadow-xl w-full max-w-xl p-6 space-y-4 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-slate-900">Add Provider</h3>
          <button type="button" onClick={onClose} className="text-slate-500 hover:text-slate-700">
            Close
          </button>
        </div>

        <NpiLookup
          onSelect={(npiResult) => {
            setProviderForm((prev) => ({
              ...prev,
              name: npiResult.providerName || prev.name,
              title: npiResult.credential || prev.title,
              organization: npiResult.organization || prev.organization,
              phone: npiResult.phone || prev.phone,
              fax: npiResult.fax || prev.fax,
              npi: npiResult.npi || prev.npi
            }));
          }}
        />

        {providerError && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded-lg text-sm">
            {providerError}
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <input
            type="text"
            placeholder="Provider name *"
            value={providerForm.name}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, name: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Title"
            value={providerForm.title}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, title: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Organization *"
            value={providerForm.organization}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, organization: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg md:col-span-2"
          />
          <input
            type="email"
            placeholder="Email"
            value={providerForm.email}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, email: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Phone"
            value={providerForm.phone}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, phone: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Fax"
            value={providerForm.fax}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, fax: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Address line 1"
            value={providerForm.addressLine1}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, addressLine1: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg md:col-span-2"
          />
          <input
            type="text"
            placeholder="Address line 2"
            value={providerForm.addressLine2}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, addressLine2: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg md:col-span-2"
          />
          <input
            type="text"
            placeholder="City"
            value={providerForm.city}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, city: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="State"
            value={providerForm.state}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, state: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
          <input
            type="text"
            placeholder="Postal code"
            value={providerForm.postalCode}
            onChange={(event) => setProviderForm((prev) => ({ ...prev, postalCode: event.target.value }))}
            className="px-3 py-2 border border-slate-300 rounded-lg"
          />
        </div>

        <div className="flex justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 text-slate-700 rounded-lg"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isSavingProvider}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg disabled:opacity-50"
          >
            {isSavingProvider ? 'Saving...' : 'Save Provider'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddProviderModal;
